import React from 'react';
import "../../../../../../styles/ambassadorChallenge/tableRowSkeleton.scss";

const TableRowSkeleton = () => {
  return (
    <div className="rt-row skeleton">
      <div className="col id skeleton-block" />
      <div className="col referrer">
        <div className="name skeleton-block" />
      </div>
      <div className="col referred">
        <div className="name skeleton-block" />
      </div>
      <div className="col date skeleton-block" />
      <div className="col progress">
        <div className="criteria-icons">
          <div className="criterion skeleton-block" />
          <div className="criterion skeleton-block" />
          <div className="criterion skeleton-block" />
        </div>
        <div className="progress-bar-wrap skeleton-block" />
      </div>
      <div className="col status">
        <div className="status-badge skeleton-block" />
      </div>
    </div>
  );
};

export default TableRowSkeleton;
